import React, {useEffect, useState, useRef} from 'react';
//components
import View from './group-view';
//utils
import {Group, OrganisationService} from '../../../utils/data-transfer';

const GroupContainer = (props) => {
  const {match} = props;
  const [state, setState] = useState({
    isLoading: true,
    group: null,
    keyMembers: [],
    members: [],
    events: [],
    pastEvents: []
  });
  const organisationService = useRef(new OrganisationService());

  useEffect(() => {
    const bootstrapComponent = async () => {
      const resp = await Promise.all([
        await Group.getGroups(match.params.groupId),
        await organisationService.current.getMembers(null, match.params.groupId),
        await Group.getGroupEvents(match.params.groupId, false),
        await Group.getGroupEvents(match.params.groupId, true),
      ]);

      const keyMembers = resp[1].filter(m => m.memberType.showSeparate);
      const members = resp[1].filter(m => !m.memberType.showSeparate);
      setState(prevState => ({...prevState, group: resp[0], keyMembers, members, events: resp[2], pastEvents: resp[3], isLoading: false}));
    };

    bootstrapComponent();
  }, []);

  return (
    <View
      {...state}/>
  );
};

export default GroupContainer;
